import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import { LicenseExtensionPurchases } from "../Sales/tabs/LicenseExtensionPurchases";
import { LicenseExtensions } from "../Sales/tabs/LicenseExtensions";
import { LicensesProvider } from "./context";
import { LicensesLayout } from "./layout";

export function Licenses() {
	return (
		<LicensesProvider>
			<Routes>
				<Route
					path="/"
					element={
						<LicensesLayout>
							<Outlet />
						</LicensesLayout>
					}
				>
					<Route path="avulsas" element={<LicenseExtensions />} />
					<Route path="compras" element={<LicenseExtensionPurchases />} />
					<Route path="/" element={<Navigate to="avulsas" replace />} />
				</Route>
			</Routes>
		</LicensesProvider>
	);
}
